import { createContext, useContext } from "react";
import { UserSelectorModalUserFragment } from "@bonliva-crm/graphql";

export type SelectOptions = {
  multi: boolean;
};

export type UserSelectorItem = UserSelectorModalUserFragment;

export type GlobalUserSelectorContextType = {
  select(options: SelectOptions): Promise<UserSelectorModalUserFragment[]>;
};

export const GlobalUserSelectorContext = createContext<GlobalUserSelectorContextType>({
  select: async () => {
    return [];
  }
});

export const GlobalUserSelectorProvider = GlobalUserSelectorContext.Provider;

export function useGlobalUserSelector() {
  const ctx = useContext(GlobalUserSelectorContext);

  if (!ctx) {
    throw new Error(
      "useGlobalUserSelector must be used within a GlobalUserSelectorProvider"
    );
  }

  return ctx;
}
